import { render } from "./Terms.vue?vue&type=template&id=685257bc"
const script = {}
script.render = render

export default script